import React, { useState } from "react";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import ContentCardBody from "../../common/template/contentCardBody";
import Select from "../../common/form/select";
import LabelAndInputDate from "../../common/form/labelAndInputDate";
import LabelAndInputTextarea from "../../common/form/labelAndTextarea";
import Button from "../../common/button/button";
import DateFormat from "../../common/dateFormat/DateFormat";

export function LogManutencaoSolarForm({ item, readOnly, tipo, handleSubmit, handleClose, listaManutencaoTipo, adicionarLogManutencao, usuarioLogado, itemSelecionado }) {
    const [formValues, setFormValues] = useState({
        id: item.id || null,
        datahora: item.datahora ? DateFormat.formatarDataSqlParaTela(item.datahora) : null,
        observacao: item.observacao || null,
        id_manutencao_tipo: item.id_manutencao_tipo || null,
        id_unidade_consumidora: item.id_unidade_consumidora || null,
    });
    return (
        <div>
            <Row>
                <Grid cols="12 12 12 12">
                    <ContentCardBody>
                        <Row>
                            <LabelAndInputDate
                                name="datahora"
                                cols="12 12 6 4"
                                label="Data"
                                value={formValues.datahora}
                                onChange={(e) =>
                                    setFormValues({
                                        ...formValues,
                                        datahora: e.target.value,
                                    })
                                }
                                readOnly={readOnly}
                            />
                        </Row>
                        <Row>
                            <LabelAndInputTextarea
                                name="observacao"
                                label="Observacao"
                                value={formValues.observacao}
                                placeholder="Informe a observação"
                                cols="12 12 12 12"
                                onChange={(valor) =>
                                    setFormValues({
                                        ...formValues,
                                        observacao: valor,
                                    })
                                }
                                readOnly={readOnly}
                            />
                        </Row>
                        <Row>
                            <Select
                                cols="12 12 12 12"
                                name="id_manutencao_tipo"
                                options={listaManutencaoTipo}
                                label="Tipo de Manutenção"
                                placeholder="Selecione o tipo de manutenção"
                                value={formValues.id_manutencao_tipo}
                                onChange={(valor) =>
                                    setFormValues({
                                        ...formValues,
                                        id_manutencao_tipo: valor,
                                    })
                                }
                                readOnly={readOnly}
                            />
                        </Row>
                        <Row alignCenter>
                            <Grid cols="6 6 4 3">
                                {tipo === "EXCLUIR" ? (
                                    <Button
                                        text="Excluir"
                                        event={() => {
                                            handleSubmit(formValues);
                                        }}
                                        type={"danger"}
                                        icon={"fa fa-trash"}
                                    />
                                ) : null}
                                {tipo === "SALVAR" ? (
                                    <Button
                                        text={"Salvar"}
                                        event={() => {
                                            handleSubmit(formValues);
                                        }}
                                        type={"success"}
                                        icon={"fa fa-check"}
                                    />
                                ) : null}
                            </Grid>
                            <Grid cols={tipo ? "6 6 4 3" : "12 12 12 12"}>
                                <Button text="Voltar" type={"warning"} icon={"fa fa-chevron-left"} event={handleClose} />
                            </Grid>
                        </Row>
                    </ContentCardBody>
                </Grid>
            </Row>
        </div>
    );
}
